/**
 * Design tokens for the shared "index icons" — the number badge and the
 * completion checkmark used by list-style blocks (accordion, checklist, flip
 * cards, quiz, …).
 *
 * Sizes AND colors live here, so a Figma change is ONE edit and stays consistent
 * everywhere. Every color is a **theme variable** — never a hardcoded hex/`white`
 * (see STANDARDS-LOMDA-V3.md §3).
 */
export const INDEX_ICON = {
    // ── sizes (Tailwind size utilities) ──
    /** Number-badge circle — Figma 40px. */
    badgeSize: "size-10",
    /** Completion-check circle — Figma 24px. */
    checkSize: "size-6",
    /** The ✓ mark inside the completion circle. */
    checkMarkSize: "size-3.5",
    /** Typography of the number/letter — Figma H6 (18px). */
    numberText: "lomda-v3-text-h6",

    // ── colors (theme variables only) ──
    /** Badge at rest: muted fill + primary number. Muted, not Background — the
     *  badge sits ON a card, and the page background can be anything. */
    badgeBg: "hsl(var(--lomda-muted))",
    badgeText: "hsl(var(--lomda-primary))",
    /** Badge active/selected: primary fill + card-coloured number. */
    badgeActiveBg: "hsl(var(--lomda-primary))",
    badgeActiveText: "hsl(var(--lomda-card))",
    /** Completion check: success circle + card-coloured ✓. */
    checkBg: "hsl(var(--lomda-success))",
    checkText: "hsl(var(--lomda-card))",
} as const;
